import React from 'react';

import i18n from 'util/i18n';
import { SUBSTANCE_USE_THC_INTRO } from 'config/formSections/substanceUse';

import SectionIntro from 'components/Section/shared/SectionIntro';

const ThcActivityIntro = function () {
  return (
    <SectionIntro
      title={i18n.t('substance.pvq.thc.intro.title')}
      body={i18n.m('substance.pvq.thc.intro.body')}
      sectionKey={SUBSTANCE_USE_THC_INTRO.key}
      isSimpleTitle
    />
  );
};

export default ThcActivityIntro;
